<script>
import Chart from 'chart.js'
import { Line as LineChartGenerator } from 'vue-chartjs'
export default {
  props: ['datasets','chartData'],
  extends: LineChartGenerator,
  data () {
    return {
      options: {
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            max: 100,
            stepSize: 10,
            reverse: false,
            beginAtZero: true
          }}]
        }
      }
    }
  },
  mounted() {
    Chart.defaults.global.legend.display = false
    this.renderChart(this.datasets, this.options)
  },
  watch: {
    datasets (val) {
      this.renderChart(this.datasets, this.options)
    }
  }
}
</script>
